// extracted by mini-css-extract-plugin
module.exports = {"verticallyCenter":"verticallyCenter--3aDtEdA9","horizontalCenter":"horizontalCenter--okV5o4xk","button":"button--sXdBmWpm","main":"main--2tDhZ6Ac"};